
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { getSupplierList, unbindSupplier } from '@/api/ccx'

@Component({})
export default class supplierList extends Vue {
  @Getter companyId!: string

  list = []
  params = {
    pageIndex: 1,
    pageSize: 10
  }
  refreshing = false
  loading = false
  finished = false

  created() {
    this.getList()
  }

  // 获取列表【上拉加载更多】
  async getList() {
    this.loading = true
    const params = {
      ...this.params,
      storeId: this.companyId
    }
    const { data } = await getSupplierList(params)
    this.list = this.list.concat(data.records)
    this.loading = false
    if (this.list.length >= data.totalRecords) {
      this.finished = true
    } else {
      this.finished = false
    }
  }

  /**
   * 下拉刷新
   * */
  async onRefresh() {
    this.list = []
    this.params.pageIndex = 1
    this.refreshing = true
    await this.getList()
    this.refreshing = false
  }

  /**
   * 上拉加载更多
   * */
  onLoad() {
    this.params.pageIndex++
    this.loading = true
    this.getList()
  }

  onUnbind(data) {
    const { autoId, supplierName } = data
    const params = {
      storeId: this.companyId,
      autoId
    }
    this.$confirmDialog.show({
      okText: '确认',
      cancelText: '取消',
      tips: `确认解除绑定供应商「${supplierName}」吗？`,
      onOk: () => {
        unbindSupplier(params).then(() => {
          this.$toast.success({
            message: '解除成功',
            duration: 1000,
            onClose: () => {
              this.onRefresh()
            }
          })
        })
      }
    })
  }
}
